export const useDisplayRelativeDate = (
  dateInput: string,
  preferDayNames: boolean = false,
  ignoreTime: boolean = false,
) => {
  const now = new Date()
  const date = new Date(dateInput)
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
  const targetDay = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()

  const MS_PER_SECOND = 1000
  const MS_PER_MINUTE = 60 * MS_PER_SECOND
  const MS_PER_HOUR = 60 * MS_PER_MINUTE
  const MS_PER_DAY = 24 * 60 * 60 * 1000
  const DAYS_PER_WEEK = 7
  const DAYS_PER_MONTH = 30.44
  const DAYS_PER_YEAR = 365.25

  const diffMs = date.getTime() - now.getTime()
  const absDiffMs = Math.abs(diffMs)
  const dayDiffMs = targetDay - today
  const diffDays = Math.round(dayDiffMs / MS_PER_DAY)
  const absDiffDays = Math.abs(diffDays)
  const rtf = new Intl.RelativeTimeFormat('de', { numeric: 'auto' })

  if (!ignoreTime) {
    if (absDiffMs < MS_PER_MINUTE) {
      return 'jetzt'
    }
    if (absDiffMs < MS_PER_HOUR) {
      return rtf.format(Math.round(diffMs / MS_PER_MINUTE), 'minute')
    }
    if (absDiffMs < MS_PER_DAY) {
      return rtf.format(Math.round(diffMs / MS_PER_HOUR), 'hour')
    }
  }

  if (preferDayNames) {
    if (absDiffDays <= 1) {
      return rtf.format(diffDays, 'day')
    }
  }

  if (absDiffDays >= DAYS_PER_YEAR) {
    return rtf.format(Math.round(diffDays / DAYS_PER_YEAR), 'year')
  }
  if (absDiffDays >= DAYS_PER_MONTH) {
    return rtf.format(Math.round(diffDays / DAYS_PER_MONTH), 'month')
  }
  if (absDiffDays >= DAYS_PER_WEEK) {
    return rtf.format(Math.round(diffDays / DAYS_PER_WEEK), 'week')
  }
  return rtf.format(diffDays, 'day')
}
